import { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import WhatsAppFloat from './components/WhatsAppFloat';
import './blog.css';

function BlogModule() {
  useEffect(() => {
    const seoNode = document.getElementById('seo-content');
    if (seoNode) seoNode.remove();
  }, []);

  return (
    <HelmetProvider>
      <Routes>
        <Route path="/" element={<Blog />} />
        <Route path="/:slug" element={<BlogPost />} />
      </Routes>
      <WhatsAppFloat />
    </HelmetProvider>
  );
}

export default BlogModule;
